import { render } from "./Widget3.vue?vue&type=template&id=a9c3b5d0"
import script from "./Widget3.vue?vue&type=script&lang=ts"
export * from "./Widget3.vue?vue&type=script&lang=ts"
script.render = render

export default script